

// z ciągu znaków typu 1|234|5, np. "wiaderko|wiaderka|wiaderek"
// wybiera formę odpowiadającą liczbie podanej jako parametr

angular.module('theme.core.filters')
.filter('pluralpl', function() {
	return function(str, number) {
		var options = str.split('|');
		if (options.length == 1) {
			return options[0];
		} else if (options.length == 2) {
			if (number == 1) {
				return options[0];
			} else {
				return options[1];
			}
		} else {
			if (number == 1) {
				return options[0];
			} else if (number % 10 >= 2 && number % 10 <= 4 && Math.floor((number % 100) / 10) != 1) {
				return options[1];
			} else {
				return options[2];
			}
		}
	}
})
